import { DropdownOption } from '../components/ui/Dropdown/Dropdown.types';
import { ComplianceStatus } from '../types/AISystems.types';

export function convertToDropdownOptions<T extends Record<string, any>>(
  items: T[],
  labelKey: keyof T,
  valueKey: keyof T
): DropdownOption[] {
  return items.map((item) => ({
    label: String(item[labelKey]),
    value: String(item[valueKey]),
  }));
}

export function isAiSystemDraftStatus(status?: ComplianceStatus | string | null) {
  return (
    status === ComplianceStatus.INITIATED ||
    status === ComplianceStatus.CLASSIFYING
  );
}
